import { type GetterTree } from 'vuex';

import { type AgreementRelationTypesState } from './types';

export const GET_AGREEMENT_RELATIONSHIP_TYPES = 'getAgreementRelationshipTypes';

export const getters: GetterTree<AgreementRelationTypesState, unknown> = {
    [GET_AGREEMENT_RELATIONSHIP_TYPES]: (_state: AgreementRelationTypesState) => {
        return _state.agreementRelationshipTypes;
    }
};
